import $ from 'jquery';
import './transition';

$.fn.extend({
    omniWindow: function(options) {
        options = $.extend(true, {
            animation: 'fade',
            animationsPriority: {
                show: ['overlay', 'modal'],
                hide: ['modal', 'overlay']
            },
            overlay: {
                selector: '.classic-modal__overlay',
                hideClass: '',
                animations: {
                    show: function(subjects, internalCallback) { return internalCallback(subjects); },
                    hide: function(subjects, internalCallback) { return internalCallback(subjects); },
                    internal: {
                        show: function(subjects) { subjects.overlay.removeClass(options.overlay.hideClass); },
                        hide: function(subjects) { subjects.overlay.addClass(options.overlay.hideClass); }
                    }
                }
            },
            modal: {
                hideClass: '',
                animations: {
                    show: function(subjects, internalCallback) {
                        var $container = $('.classic-modal__container'),
                            $inner = $('.classic-modal__inner');

                        $('body')
                            .attr('data-modal-status', 'active');

                        $container
                            .attr('data-modal-animation', options.animation)
                            .attr('data-modal-status', 'activating')
                            .offset(); // force reflow

                        // show animate modal
                        $inner.transitionEnd(function() {
                            return internalCallback(subjects);
                        });

                        $container
                            .attr('data-modal-status', 'active');
                    },
                    hide: function(subjects, internalCallback) {
                        var $container = $('.classic-modal__container'),
                            $inner = $('.classic-modal__inner');

                        $inner.transitionEnd(function() {
                            return internalCallback(subjects);
                        });

                        if ($.support.transition) {
                            $container.attr('data-modal-status', 'closing');
                        }
                    },
                    internal: {
                        show: function(subjects) { subjects.modal.removeClass(options.modal.hideClass); },
                        hide: function(subjects) { subjects.modal.addClass(options.modal.hideClass); }
                    }
                },
                internal: {
                    stateAttribute: 'ow-active'
                }
            },
            eventsNames: {
                show: 'show.ow',
                hide: 'hide.ow',
                internal: {
                    overlayClick: 'click.ow',
                    keyboardKeyUp: 'keyup.ow'
                }
            },
            callbacks: {
                beforeShow: function(subjects, internalCallback) {
                    var $modal = subjects.modal,
                        modal = $modal.data('modal'),
                        $container = $('.classic-modal__container'),
                        $inner = $('.classic-modal__inner'),
                        $liner = $('.classic-modal__liner'),
                        $placeholder = $('<div>').hide();

                    $container.addClass(options.variations.split(' ').map(function(item, i) {
                        //
                        // sanitise `modal__container--` prefixes on variations
                        //
                        return 'classic-modal__container--' + item.replace(/^classic-modal__container--/, '');
                    }).join(' '));

                    $container.attr('data-modal-scroll', options.scroll);
                    $container.attr('data-modal-closeable', options.closeable);
                    $inner.addClass(options['class']);

                    $(document).trigger('modal:beforeShow:' + modal.getName(), [modal]);

                    if (!modal.canProceed()) {
                        return false;
                    }

                    $modal
                        // store the placeholder to retrieval later
                        .data('modal-placeholder', $placeholder)
                        // leave a marker for where to return the modal to
                        .before($placeholder)
                        // add modal content to modal wrapper
                        .appendTo($liner);

                    return internalCallback(subjects);
                },
                positioning: function(subjects, internalCallback) {
                    var modal = subjects.modal.data('modal');

                    $(document).trigger('modal:positioning:' + modal.getName(), modal);

                    return internalCallback({
                        modal: subjects.modal.parent(),
                        overlay: subjects.overlay
                    });
                },
                afterShow: function(subjects, internalCallback) {
                    var modal = $(subjects.modal).data('modal');

                    $(document).trigger('modal:afterShow:' + modal.getName(), modal);

                    $('.classic-modal__inner').on('click', function(e) {
                        if ($(e.target).hasClass('classic-modal__inner')) {
                            modal.hide();
                        }
                    });

                    return internalCallback(subjects);
                },
                beforeHide: function(subjects, internalCallback) {
                    var modal = $(subjects.modal).data('modal');

                    $(document).trigger('modal:beforeHide:' + modal.getName(), modal);

                    if (modal.canProceed()) {
                        return internalCallback(subjects);
                    }

                    return false;
                },
                afterHide: function(subjects, internalCallback) {
                    var $modal = subjects.modal,
                        modal = $modal.data('modal'),
                        $container = $('.classic-modal__container'),
                        $inner = $('.classic-modal__inner'),
                        $placeholder = $modal.data('modal-placeholder');

                    $container.attr('class', 'classic-modal__container');
                    $inner.attr('class', 'classic-modal__inner');

                    $(document).trigger('modal:afterHide:' + modal.getName(), modal);

                    $placeholder
                        .after(subjects.modal)
                        .remove();

                    $container
                        .removeAttr('data-modal-status')
                        .removeAttr('data-modal-animation')
                        .removeAttr('data-modal-scroll')
                        .removeAttr('data-modal-closeable');

                    $container.hide(0); // force reflow

                    $('body')
                        .removeAttr('data-modal-status')
                        .removeAttr('data-modal-scroll');

                    return internalCallback(subjects);
                },
                internal: {
                    beforeShow: function(subjects) {
                        if (subjects.modal.data(options.modal.internal.stateAttribute)) {
                            return false;
                        } else {
                            subjects.modal.data(options.modal.internal.stateAttribute, true);
                            return true;
                        }
                    },
                    afterShow: function(subjects) {
                        $(document).on(options.eventsNames.internal.keyboardKeyUp, function(e) {
                            // if the key pressed is the ESC key
                            var canClose = $('.classic-modal__container').attr('data-modal-closeable') === 'true';

                            if (e.keyCode === 27 && canClose) {
                                subjects.modal.trigger(options.eventsNames.hide);
                            }
                        });

                        subjects.overlay.on(options.eventsNames.internal.overlayClick, function() {
                            subjects.modal.trigger(options.eventsNames.hide);
                        });
                    },
                    positioning: function(subjects) {
                        subjects.modal.css('margin-left', Math.round(subjects.modal.outerWidth() / -2));
                    },
                    beforeHide: function(subjects) {
                        if (subjects.modal.data(options.modal.internal.stateAttribute)) {
                            subjects.modal.data(options.modal.internal.stateAttribute, false);
                            return true;
                        } else {
                            return false;
                        }
                    },
                    afterHide: function(subjects) {
                        subjects.overlay.off(options.eventsNames.internal.overlayClick);
                        $(document).off(options.eventsNames.internal.keyboardKeyUp);

                        subjects.overlay.css('display', ''); // clear inline styles after jQ animations
                        subjects.modal.css('display', '');
                    }
                }
            }
        }, options);

        var animate = function(process, subjects, callbackName) {
            var first = options.animationsPriority[process][0],
                second = options.animationsPriority[process][1];

            options[first].animations[process](subjects, function(subjs) {        // call USER's    FIRST animation (depends on priority)
                options[first].animations.internal[process](subjs);                 // call internal  FIRST animation

                options[second].animations[process](subjects, function(subjs) {     // call USER's    SECOND animation
                    options[second].animations.internal[process](subjs);              // call internal  SECOND animation

                    // then we need to call USER's
                    // afterShow of afterHide callback
                    options.callbacks[callbackName](subjects, options.callbacks.internal[callbackName]);
                });
            });
        };

        var showModal = function(subjects) {
            if (!options.callbacks.beforeShow(subjects, options.callbacks.internal.beforeShow)) { return; } // cancel showing if beforeShow callback return false

            options.callbacks.positioning(subjects, options.callbacks.internal.positioning);

            animate('show', subjects, 'afterShow');
        };

        var hideModal = function(subjects) {
            if (!options.callbacks.beforeHide(subjects, options.callbacks.internal.beforeHide)) { return; } // cancel hiding if beforeHide callback return false

            animate('hide', subjects, 'afterHide');
        };

        var $overlay = $(options.overlay.selector);

        return this.each(function() {
            var $modal = $(this);
            var subjects = {modal: $modal, overlay: $overlay};

            $modal
                .bind(options.eventsNames.show, function() { showModal(subjects); })
                .bind(options.eventsNames.hide, function() { hideModal(subjects); });
        });
    }
});



// WEBPACK FOOTER //
// ./~/@99designs/asimov/modal/lib/modal-vendor.js